export default "__VITE_ASSET__4f98bc04__"